// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingItem-textEllipsis-lytin {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.ListingItem-listInfoLink-rK09G {
	cursor: pointer;
	display: block;
	text-decoration: none !important;
}

.ListingItem-listingInfo-HRkHf {
	word-wrap: break-word;
	font-size: 14px;
	color: var(--secondary-foreground);
}

.ListingItem-displayInline-Leaqt {
	display: inline-block;
}

.ListingItem-listingTitle-ViTt2 {
	font-size: 16px;
	color: var(--primary-foreground);
}

.ListingItem-infoPrice-lPkQP {
	font-size: 18px;
	color: var(--primary-foreground);
}

.ListingItem-infoReview-IN9nX {
	word-wrap: break-word;
	font-size: 16px;
	line-height: 16px;
	letter-spacing: normal;
	color: var(--primary-foreground);
	display: inline;
}

.ListingItem-instantIcon-V7d4O {
	color: var(--instantIcon-bg);
	height: 16px;
	width: 16px;
}

.ListingItem-pernightText-TG2Hc {
	font-size: 14px;
}

.ListingItem-reviewStarGap-oOlC0 {
	gap: 4px;
}

.ListingItem-listFlex-vJg0Q {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.ListingItem-currencyText-tZMqM,
.ListingItem-currencyText-tZMqM:hover,
.ListingItem-currencyText-tZMqM:active,
.ListingItem-currencyText-tZMqM:focus {
	font-size: 16px;
	font-weight: 600;
	color: var(--primary-foreground);
	text-decoration: none;
}

.ListingItem-listItemContainer-U5G9S {
	margin-bottom: 8px;
	position: relative;
}

.ListingItem-mapListItemPadding-jh6aM {
	padding: 0px 12px 12px;
}

.ListingItem-listPhotoContainer-dkcXY {
	position: relative !important;
	height: 100% !important;
	background: var(--background-primary);
	border-radius: 15px;
	border: 1px solid var(--primary-border);
}

.ListingItem-priceBreakDownText-ZKea9 {
	font-size: 18px;
	font-weight: 500;
	color: var(--primary-foreground);
	margin: 0px;
	text-align: center;
}

.ListingItem-popUpTitleSection-EtzAW {
	display: grid;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-template-columns: 15px auto;
	padding: 18px 24px;
	border-bottom: 1px solid var(--primary-border);
}

.ListingItem-paddingTop-UHh1u {
	padding-top: 12px !important;
}

.ListingItem-totalText-icrOa {
	padding-top: 18px !important;
	padding-bottom: 18px !important;
	color: var(--primary-foreground) !important;
	font-size: 16px !important;
	font-weight: 500 !important;
}

.ListingItem-cursorPointer-Y0_yV {
	cursor: pointer;
}

.ListingItem-totalBeforeTaxText-E2_0m {
	font-size: 14px;
	font-weight: normal;
}

.ListingItem-showPriceValueFlex-xb177 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	gap: 4px;
}

@media screen and (min-width: 321px) {
	.ListingItem-listItemContainer-U5G9S {
		width: 100%;
	}
}

@media screen and (max-width: 767px) {
	.ListingItem-popUpSection-hJyyH {
		display: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/ListingItem/ListingItem.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;;;;CAIC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;CAC7B,uBAAuB;CACvB,qCAAqC;CACrC,mBAAmB;CACnB,uCAAuC;AACxC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gCAAgC;CAChC,kBAAkB;CAClB,8CAA8C;AAC/C;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;CAC/B,2CAA2C;CAC3C,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,QAAQ;AACT;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD","sourcesContent":[".textEllipsis {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.listInfoLink {\n\tcursor: pointer;\n\tdisplay: block;\n\ttext-decoration: none !important;\n}\n\n.listingInfo {\n\tword-wrap: break-word;\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.listingTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.infoPrice {\n\tfont-size: 18px;\n\tcolor: var(--primary-foreground);\n}\n\n.infoReview {\n\tword-wrap: break-word;\n\tfont-size: 16px;\n\tline-height: 16px;\n\tletter-spacing: normal;\n\tcolor: var(--primary-foreground);\n\tdisplay: inline;\n}\n\n.instantIcon {\n\tcolor: var(--instantIcon-bg);\n\theight: 16px;\n\twidth: 16px;\n}\n\n.pernightText {\n\tfont-size: 14px;\n}\n\n.reviewStarGap {\n\tgap: 4px;\n}\n\n.listFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.currencyText,\n.currencyText:hover,\n.currencyText:active,\n.currencyText:focus {\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none;\n}\n\n.listItemContainer {\n\tmargin-bottom: 8px;\n\tposition: relative;\n}\n\n.mapListItemPadding {\n\tpadding: 0px 12px 12px;\n}\n\n.listPhotoContainer {\n\tposition: relative !important;\n\theight: 100% !important;\n\tbackground: var(--background-primary);\n\tborder-radius: 15px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.priceBreakDownText {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: var(--primary-foreground);\n\tmargin: 0px;\n\ttext-align: center;\n}\n\n.popUpTitleSection {\n\tdisplay: grid;\n\talign-items: center;\n\tgrid-template-columns: 15px auto;\n\tpadding: 18px 24px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.paddingTop {\n\tpadding-top: 12px !important;\n}\n\n.totalText {\n\tpadding-top: 18px !important;\n\tpadding-bottom: 18px !important;\n\tcolor: var(--primary-foreground) !important;\n\tfont-size: 16px !important;\n\tfont-weight: 500 !important;\n}\n\n.cursorPointer {\n\tcursor: pointer;\n}\n\n.totalBeforeTaxText {\n\tfont-size: 14px;\n\tfont-weight: normal;\n}\n\n.showPriceValueFlex {\n\tdisplay: flex;\n\tgap: 4px;\n}\n\n@media screen and (min-width: 321px) {\n\t.listItemContainer {\n\t\twidth: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.popUpSection {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textEllipsis": `ListingItem-textEllipsis-lytin`,
	"listInfoLink": `ListingItem-listInfoLink-rK09G`,
	"listingInfo": `ListingItem-listingInfo-HRkHf`,
	"displayInline": `ListingItem-displayInline-Leaqt`,
	"listingTitle": `ListingItem-listingTitle-ViTt2`,
	"infoPrice": `ListingItem-infoPrice-lPkQP`,
	"infoReview": `ListingItem-infoReview-IN9nX`,
	"instantIcon": `ListingItem-instantIcon-V7d4O`,
	"pernightText": `ListingItem-pernightText-TG2Hc`,
	"reviewStarGap": `ListingItem-reviewStarGap-oOlC0`,
	"listFlex": `ListingItem-listFlex-vJg0Q`,
	"currencyText": `ListingItem-currencyText-tZMqM`,
	"listItemContainer": `ListingItem-listItemContainer-U5G9S`,
	"mapListItemPadding": `ListingItem-mapListItemPadding-jh6aM`,
	"listPhotoContainer": `ListingItem-listPhotoContainer-dkcXY`,
	"priceBreakDownText": `ListingItem-priceBreakDownText-ZKea9`,
	"popUpTitleSection": `ListingItem-popUpTitleSection-EtzAW`,
	"paddingTop": `ListingItem-paddingTop-UHh1u`,
	"totalText": `ListingItem-totalText-icrOa`,
	"cursorPointer": `ListingItem-cursorPointer-Y0_yV`,
	"totalBeforeTaxText": `ListingItem-totalBeforeTaxText-E2_0m`,
	"showPriceValueFlex": `ListingItem-showPriceValueFlex-xb177`,
	"popUpSection": `ListingItem-popUpSection-hJyyH`
};
module.exports = ___CSS_LOADER_EXPORT___;
